import * as Immutable from 'immutable';
import {
  GET_DOCUMENTS_ABORTED,
  GET_DOCUMENTS_REQUESTED,
  GET_DOCUMENTS_COMPLETED,
  GET_DOCUMENTS_FAILED,
  DOWNLOAD_DOCUMENT_REQUESTED,
  DOWNLOAD_DOCUMENT_COMPLETED,
  DOWNLOAD_DOCUMENT_FAILED,
  VIEW_DOCUMENT_REQUESTED,
  VIEW_DOCUMENT_COMPLETED,
  VIEW_DOCUMENT_FAILED,
  RESET_VIEW_DOCUMENT_REQUESTED,
  RESET_VIEW_DOCUMENT_COMPLETED,
  RESET_VIEW_DOCUMENT_FAILED,
  GET_IPADDRESS_REQUESTED,
  GET_IPADDRESS_COMPLETED,
  GET_IPADDRESS_FAILED,
  GET_SHAREPOINTDOCUMENTS_REQUESTED,
  GET_SHAREPOINTDOCUMENTS_COMPLETED,
  GET_SHAREPOINTDOCUMENTS_FAILED,
  SET_DOCUMENTS_REDIRECTROUTE_REQUESTED,
  SET_DOCUMENTS_REDIRECTROUTE_COMPLETED,
  // SET_DOCUMENTS_REDIRECTROUTE_ABORTED,
  SET_DOCUMENTS_REDIRECTROUTE_FAILED,
  RESET_DOCUMENTS_REDIRECTROUTE_REQUESTED,
  RESET_DOCUMENTS_REDIRECTROUTE_COMPLETED,
  // SET_DOCUMENTS_REDIRECTROUTE_ABORTED,
  RESET_DOCUMENTS_REDIRECTROUTE_FAILED,

  // RESET_DOCUMENTS_REQUESTED,
  // RESET_DOCUMENTS_COMPLETED,
} from '../../actions/documents/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: null },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,

  downloadingdata: false,
  downloadeddata: false,

  gettingipaddress: false,
  gotipaddress: false,
  ipaddress: null,

  gettingsharepointdocuments: false,
  gotsharepointdocuments: false,
  sharepointdocuments: null,
  // Document currently being viewed
  documentfile: null,
  documentsredirectroute: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DOCUMENTS_REDIRECTROUTE_REQUESTED:
      return state
        .set('gettingdata', true)
        .set('error', null)
        .set('documentsredirectroute', false);

    case SET_DOCUMENTS_REDIRECTROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('documentsredirectroute', true);

    case SET_DOCUMENTS_REDIRECTROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case RESET_DOCUMENTS_REDIRECTROUTE_REQUESTED:
      return state.set('gettingdata', true).set('error', null);

    case RESET_DOCUMENTS_REDIRECTROUTE_COMPLETED:
      return state.set('documentsredirectroute', false);

    case RESET_DOCUMENTS_REDIRECTROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case GET_DOCUMENTS_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_DOCUMENTS_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_DOCUMENTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_DOCUMENTS_FAILED:
      // Clear the loading flag too, or the page spins forever instead of
      // showing the error (e.g. SharePoint unavailable).
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case DOWNLOAD_DOCUMENT_REQUESTED:
      return state
        .set('error', null)
        .set('downloadingdata', true)
        .set('data', action.payload);

    case DOWNLOAD_DOCUMENT_COMPLETED:
      return state
        .set('error', null)
        .set('downloadingdata', false)
        .set('downloadeddata', true)
        .set('data', action.payload);

    case DOWNLOAD_DOCUMENT_FAILED:
      return state.set('error', action.payload);

    case VIEW_DOCUMENT_REQUESTED:
      return state
        .set('error', null)
        .set('downloadingdata', true)
        .set('documentfile', null)
        .set('data', action.payload);

    case VIEW_DOCUMENT_COMPLETED:
      return state
        .set('error', null)
        .set('downloadingdata', false)
        .set('downloadeddata', true)
        .set('documentfile', action.payload.file)
        .set('data', action.payload.data);

    case VIEW_DOCUMENT_FAILED:
      return state.set('documentfile', null).set('error', action.payload.error);

    case RESET_VIEW_DOCUMENT_REQUESTED:
      return state.set('error', null).set('downloadingdata', true);

    case RESET_VIEW_DOCUMENT_COMPLETED:
      return state
        .set('error', null)
        .set('downloadingdata', false)
        .set('downloadeddata', false)
        .set('documentfile', null);

    case RESET_VIEW_DOCUMENT_FAILED:
      return state.set('error', action.payload);

    case GET_IPADDRESS_REQUESTED:
      return state.set('error', null).set('gettingipaddress', true);

    case GET_IPADDRESS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingipaddress', false)
        .set('gotipaddress', true)
        .set('ipaddress', action.payload);

    case GET_IPADDRESS_FAILED:
      return state.set('error', action.payload);

    case GET_SHAREPOINTDOCUMENTS_REQUESTED:
      return state.set('error', null).set('gettingsharepointdocuments', true);

    case GET_SHAREPOINTDOCUMENTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingsharepointdocuments', false)
        .set('gotsharepointdocuments', true)
        .set('sharepointdocuments', action.payload);

    case GET_SHAREPOINTDOCUMENTS_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
